<template>
    <div class="common-upload">
        <div v-if="pageInfo" :class="`${!vStyle ? 'flex-start' : 'flex'}`">
            <div v-for="(_file, index) in form[fileParamName]" :key="index" :style="{marginRight: span + 'px'}">
                <div v-if="vStyle && _file.file" @click="previewImg(_file.file)">
                    <i class="el-icon-document"></i>
                    <label v-if="_file.required" style="color: red">*</label>
                    {{ _file.title }}
                </div>
                <div v-else-if="_file.file" style="display: flex; flex-direction: column; align-items: center; justify-content: center">
                    <span class="demonstration">{{ _file.title }}</span>
                    <el-image v-if="['pdf', 'docx', 'doc', 'xls', 'xlsx', 'et'].includes(getFileExtension(_file.file))" style="width: 60px; height: 60px; border-radius: 4px" :src="`../../../static/img/ims/${getFileExtension(_file.file)}.png`" @click="previewImg(_file.file)"></el-image>
                    <el-image v-else style="width: 60px; height: 60px; border-radius: 4px" :src="_file.file" @click.stop="previewImg(_file.file)"></el-image>
                </div>
                <div v-else style="display: flex; flex-direction: column; align-items: center; justify-content: center">
                    <span class="demonstration">{{ _file.title }}</span>
                    <div class="avatar-block">
                        <span style="width: 60px; height: 60px; border-radius: 4px; text-align: center; color: grey" class="avatar">未上传</span>
                    </div>
                </div>
            </div>
        </div>

        <div v-else class="flex-start">
            <template v-if="!vStyle">
                <div v-for="(_file, index) in form[fileParamName]" :key="index" :style="{marginRight: span + 'px'}">
                    <span class="demonstration">
                        <label v-if="_file.required" style="color: red">*</label>
                        {{ _file.title }}
                    </span>
                    <div v-if="_file.file" class="avatar-block">
                        <el-image v-if="['pdf', 'docx', 'doc', 'xls', 'xlsx', 'et'].includes(getFileExtension(_file.file))" :src="`../../../static/img/ims/${getFileExtension(_file.file)}.png`" class="avatar" style="border-radius: 4px"></el-image>
                        <el-image v-else :src="_file.file" class="avatar" style="border-radius: 4px" />
                        <span class="el-upload-list__item-delete">
                            <i class="el-icon-zoom-in" @click.stop="previewImg(_file.file)"></i>
                            <i class="el-icon-delete" @click.stop="_file.file = ''"></i>
                        </span>
                    </div>
                    <!-- :prop="_file.file"  -->

                    <el-form-item v-else label-width="0" label="" :prop="`${fileParamName}[${index}].file`" :rules="[{required: _file.required, message: ' '}]">
                        <el-upload class="avatar-uploader" action="#" :http-request="file => handleUploadFile(file, index)" :show-file-list="showFileList" :before-upload="beforeUpload" :accept="accept">
                            <i class="el-icon-plus avatar-uploader-icon"></i>
                        </el-upload>
                    </el-form-item>
                </div>
            </template>
            <!-- 行表格式上传 -->
            <template v-else>
                <el-upload
                    :on-preview="file => previewImg(file.url)"
                    class="upload-demo"
                    :file-list="form[fileParamName]"
                    action="#"
                    :on-remove="handleRemove"
                    multiple
                    :limit="limit"
                    :on-exceed="handleExceed"
                    :http-request="file => handleUploadFile(file)"
                    :show-file-list="true"
                    :before-upload="beforeUpload"
                    :accept="accept">
                    <div>
                        <span slot="tip" class="el-upload__primary" style="color: blue">点此上传</span>
                        <span slot="tip" class="el-upload__tip">（支持jpg/png/pdf文件,不超过10MB）</span>
                    </div>
                </el-upload>
            </template>
        </div>
    </div>
</template>
<script>
import {uploadFile} from '@/services/ims';
export default {
    props: {
        pageInfo: {
            type: Boolean,
            default: false,
        },
        showFileList: {
            type: Boolean,
            default: false,
        },
        // 文件个数为5的限制
        limit: {
            type: Number,
            default: 10,
        },
        filesList: {
            type: Array,
            default: () => {
                return [];
            },
        },
        accept: {
            type: String,
            default: '.jpg,.png,.pdf,.xls,.jpeg,.doc,.docx,.wps,.xlsx,.et',
        },
        span: {
            type: Number,
            default: 8,
        },
        vStyle: {
            type: Boolean,
            default: false,
        },
        form: {
            type: Object,
            default: () => {},
        },
        fileParamName: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            // form: {
            // filesListArray: [],
            // },
        };
    },
    // watch: {
    //     filesList: {
    //         handler() {
    //             // this.filesListArray = this.filesList || [];
    //             // if (this.vStyle) {
    //             // this.filesListArray.map(item => {
    //             //     item.name = item.title;
    //             //     item.url = item.file;
    //             // });
    //             // } else {
    //             // this.uploadFileAdd();
    //             // }
    //         },
    //         immediate: true,
    //         deep: true,
    //     },
    // },
    created() {},
    methods: {
        getFileExtension(fileName) {
            var parts = fileName.split('.');
            var ext = (parts[parts.length - 1] + '').toLocaleLowerCase();
            return ext;
        },
        previewImg(file) {
            window.open(file);
        },
        handleExceed(files, fileList) {
            this.$message.warning(`当前限制选择 ${this.limit}  个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
        },
        beforeUpload(file) {
            // console.log(file);
            const isJPG = file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'application/pdf';
            const isLt2M = file.size / 1024 < 10240000;

            // if (!isJPG) {
            // this.$message.error('上传文件只能是 JPG/PNG/PDF 格式!');
            // }
            if (!isLt2M) {
                this.$message.error('上传文件大小不能超过 10MB!');
            }
            return isLt2M;
            // return isJPG && isLt2M;
        },
        // 处理文件上传操作
        async handleUploadFile(file, index) {
            // 调用后端服务器的接口
            const formData = new FormData();
            formData.append('file', file.file);
            formData.append('type', 1);
            const response = await uploadFile(formData);
            if (response.state == 1) {
                this.$message.success(` ${file.file.name}  上传服务器成功 !`);
                if (this.vStyle) {
                    this.form[this.fileParamName] = this.form[this.fileParamName] || [];
                    this.form[this.fileParamName].push({
                        file: response.data.url,
                        title: file.file.name,
                        name: file.file.name,
                        url: response.data.url,
                    });
                } else {
                    this.form[this.fileParamName][index].file = response.data.url;
                }
                if (this.limit) {
                    this.uploadFileAdd();
                }
            } else {
                this.$message.warning(` ${file.file.name}  上传失败 !`);
            }
        },
        handleRemove(file, fileList) {
            this.form[this.fileParamName] = fileList;
        },
        validateForm() {
            this.$refs.childForm.validate(valid => {
                if (valid) {
                    console.log('submit!!');
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        uploadFileAdd() {
            // if (this.filesListArray.length < this.limit) {
            //     let flag = true;
            //     this.filesListArray.map((item, index) => {
            //         if (index != 0) {
            //             if (!item.file) {
            //                 flag = false;
            //                 return;
            //             }
            //         }
            //     });
            //     if (flag) {
            //         this.filesListArray.push({
            //             title: '其它',
            //             file: '',
            //         });
            //     }
            // }
        },
    },
};
</script>
<style lang="scss" scoped>
.common-upload {
    width: max-content;
    .avatar-block {
        position: relative;
        &:hover {
            .el-upload-list__item-delete {
                opacity: 1;
            }
        }
        .el-upload-list__item-delete {
            position: absolute;
            width: 60px;
            height: 60px;
            left: 0;
            top: 0;
            cursor: pointer;
            text-align: center;
            color: #fff;
            opacity: 0;
            border-radius: 4px;
            font-size: 18px;
            background-color: rgba(0, 0, 0, 0.5);
            transition: opacity 0.3s;
            display: block;
            &:after {
                display: inline-block;
                content: '';
                height: 100%;
                vertical-align: middle;
            }
        }
    }
    .avatar-uploader {
        /deep/ .el-upload {
            border: 1px dashed #d9d9d9;
            border-radius: 6px;
            cursor: pointer;
            position: relative;
            overflow: hidden;
            &:hover {
                border-color: #409eff;
            }
        }
    }

    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 60px;
        height: 60px;
        line-height: 60px;
        text-align: center;
    }
    .avatar {
        width: 60px;
        height: 60px;
        display: block;
    }
    .flex {
        display: flex;
        flex-direction: column;
        cursor: pointer;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/Upload/index.vue